import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Glasses } from 'lucide-react';
import { LanguageSwitcher } from '@/components/layout/LanguageSwitcher';

/** Centred shell for unauthenticated pages. */
export function AuthLayout() {
  const { t } = useTranslation();

  return (
    <div className="bg-canvas flex min-h-dvh flex-col">
      <div className="flex justify-end p-4">
        <LanguageSwitcher />
      </div>

      <div className="flex flex-1 items-center justify-center px-4 pb-16">
        <div className="w-full max-w-sm">
          <div className="mb-8 flex flex-col items-center gap-3">
            <span className="bg-brand-600 grid size-12 place-items-center rounded-xl text-white">
              <Glasses className="size-6" aria-hidden />
            </span>
            <h1 className="text-ink text-xl font-semibold">{t('common.appName')}</h1>
          </div>

          <Outlet />
        </div>
      </div>
    </div>
  );
}
